"use client"

import { Banner } from '@/app/components/Banner'
import ServiceContent from '@/app/components/ServiceContent'
import { analyticSolutionsImg } from '@/assets/imgs'
import { useTranslations } from 'next-intl'


const AnalyticSolutions = () => {
  const  t  = useTranslations()
  return (
    <>
      <Banner
        subUrl={t('links.services')}
        name={t('links.analyticSolutions')}
        description={t('analyticSolutions.bannerDescription')}
        className='bg-analyticSolutions'
      />
      <ServiceContent
        title={t('links.analyticSolutions')}
        header={t('analyticSolutions.header')}
        subContent={t('analyticSolutions.subTitle')}
        content={t('analyticSolutions.content')}
        img={analyticSolutionsImg}
      />
    </>
  )
}

export default AnalyticSolutions
